import { useSelector } from 'react-redux';
import * as ROUTES from '../constants';
import { getIsLoggedIn, getPermission } from '../redux/login/loginReducer';
import { routesAndComponents } from './_routesAndComponents';

const hasPermission = route => {
	let fiscalCanSee = [
		ROUTES.URI_HOME,
		ROUTES.LOAD_PRECEEDING,
		ROUTES.LIST_OF_PRECEEDING,
		ROUTES.PROFILE,
		ROUTES.LIST_OF_PARTICIPATIONS,
		/* ROUTES.LIST_OF_PARTICIPATIONS_DNI, */
	];
	return fiscalCanSee.includes(route);
};

const showComponent = (route, isGeneralFiscal) => {
	let componenetAndIcons = {
		component: null,
		name: null,
		to: null,
		icon: null,
	};
	routesAndComponents.forEach(element => {
		if (route === element.to && (isGeneralFiscal || hasPermission(route))) {
			componenetAndIcons.componenet = element.componenet;
			componenetAndIcons.name = element.name;
			componenetAndIcons.to = element.to;
			componenetAndIcons.icon = element.icon;
		}
	});

	return componenetAndIcons;
};

export const NavRoutes = () => {
	const isLoggedIn = useSelector(state => getIsLoggedIn(state));
	const isGeneralFiscal = useSelector(state => getPermission(state));
	let arrayRoutes = [];
	let routes;

	if (isLoggedIn) {
		arrayRoutes.push(ROUTES.URI_HOME);
		arrayRoutes.push(ROUTES.LOAD_PRECEEDING);
		arrayRoutes.push(ROUTES.LIST_OF_PRECEEDING);
		arrayRoutes.push(ROUTES.LIST_OF_PARTICIPATIONS);
		/* 	arrayRoutes.push(ROUTES.LIST_OF_PARTICIPATIONS_DNI); */
		arrayRoutes.push(ROUTES.PROFILE);

		routes = arrayRoutes.map(item => {
			let data = {};
			let componenetItems = showComponent(item, isGeneralFiscal);
			if (componenetItems.name !== null) {
				if (isGeneralFiscal && componenetItems.to) {
					data = {
						name: componenetItems.name,
						show: isGeneralFiscal,
						component: componenetItems.componenet,
						icon: componenetItems.icon,
						to: componenetItems.to,
					};
				} else {
					if (hasPermission(item)) {
						data = {
							name: componenetItems.name,
							show: hasPermission(item),
							component: componenetItems.componenet,
							icon: componenetItems.icon,
							to: componenetItems.to,
						};
					}
				}
			}

			return data;
		});
	}
	let routesToMap = [];
	if (routes) {
		for (let index = 0; index < routes.length; index++) {
			if (routes[index].name) {
				routesToMap.push(routes[index]);
			}
		}
	}
	return routesToMap;
};
